import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navigation from "../components/navigation";
import { signupMarketplace } from "../api/marketplaceAuth";
import "../styles/admin-login.css";



export default function Signup() {
  const navigate = useNavigate();
  const [role, setRole] = useState("buyer");
  const [form, setForm] = useState({
    email: "",
    password: "",
    fullName: "",
    yardName: "",
    phone: "",
    whatsappPhone: "",
    location: "",
  });
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const set = (key) => (event) =>
    setForm({ ...form, [key]: event.target.value });
  async function submit(event) {
    event.preventDefault();
    setError("");
    setSaving(true);
    try {
      await signupMarketplace({ ...form, role });
      navigate("/login");
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setSaving(false);
    }
  }
  return (
    <main className="">
      <Navigation />
      <section className="mx-auto max-w-md px-6 py-20">
        <div className="rounded-2xl border border-border bg-white p-8 shadow-sm admin-login__card">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#c1392a]">
            My Car Kenya
          </p>
          <h1 className="mt-3 font-heading text-3xl font-bold text-dark">
            Create your account
          </h1>
          <p className="mt-2 text-sm text-muted">
            Join the marketplace as a buyer or seller.
          </p>
          <div className="mt-7 grid grid-cols-2 rounded-lg themed p-1">
            {["buyer", "seller"].map((option) => (
              <button
                key={option}
                type="button"
                onClick={() => setRole(option)}
                className={`rounded-md px-4 py-3 text-sm font-semibold capitalize ${role === option ? "bg-white text-[#c1392a] shadow-sm" : "text-muted"}`}
              >
                I am {option === "buyer" ? "buying" : "selling"}
              </button>
            ))}
          </div>
          <form onSubmit={submit} className="mt-7 grid gap-4">
            {role === "buyer" && <label className="grid gap-2 text-sm font-semibold text-dark">Full name<input required value={form.fullName} onChange={set("fullName")} className="rounded-lg border border-border px-4 py-3 font-normal outline-none focus:border-[#c1392a]" /></label>}
            {[
              ["email", "Email address", "email"],
              ["password", "Password (at least 8 characters)", "password"],
            ].map(([key, label, type]) => (
              <label
                key={key}
                className="grid gap-2 text-sm font-semibold text-dark"
              >
                {label}
                <input
                  required
                  type={type}
                  value={form[key]}
                  onChange={set(key)}
                  className="rounded-lg border border-border px-4 py-3 font-normal outline-none focus:border-[#c1392a]"
                />
              </label>
            ))}
            {role === "buyer" && <label className="grid gap-2 text-sm font-semibold text-dark">Phone number<input required value={form.phone} onChange={set("phone")} className="rounded-lg border border-border px-4 py-3 font-normal outline-none focus:border-[#c1392a]" /></label>}
            {role === "seller" && (
              <div className="grid gap-4 border-t border-border pt-4">
                {[
                  ["fullName", "Full name"],
                  ["yardName", "Yard / shop name"],
                  ["phone", "Contact number"],
                  ["whatsappPhone", "WhatsApp number"],
                  ["location", "Location"],
                ].map(([key, label]) => (
                  <label
                    key={key}
                    className="grid gap-2 text-sm font-semibold text-dark"
                  >
                    {label}
                    <input
                      required
                      value={form[key]}
                      onChange={set(key)}
                      className="rounded-lg border border-border px-4 py-3 font-normal outline-none focus:border-[#c1392a]"
                    />
                  </label>
                ))}
                <p className="text-xs text-muted">
                  Your yard name and location will appear with your listings.
                  These details let buyers contact you directly from your listings.
                </p>
              </div>
            )}
            {error && (
              <p
                role="alert"
                className="rounded-lg bg-red-50 p-3 text-sm text-red-700"
              >
                {error}
              </p>
            )}
            <button
              disabled={saving}
              className="mt-2 rounded-lg bg-[#c1392a] px-5 py-3 font-semibold text-white disabled:opacity-60"
            >
              {saving ? "Creating account..." : "Create account"}
            </button>
          </form>
          <p className="mt-6 text-center text-sm text-muted">
            Already have an account?{" "}
            <Link to="/login" className="font-semibold text-[#c1392a]">
              Sign in
            </Link>
          </p>
        </div>
      </section>
    </main>
  );
}
